export default __webpack_public_path__ + "static/media/mountain-fog-crop.ce473bec.jpg";